module.exports = __webpack_public_path__ + "img/PriceChart.15728396.svg";